module.exports = __webpack_public_path__ + "img/union2Img.afdc7424.png";